import React, { useRef, useEffect, memo, useState } from 'react';

//Dependencies.
import { Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

//Slices.
import { allUsers, logUserIn, loggedInUser, loginThunk } from '../../../slices/allUsersSlice';

import "./LoginForm.styles.css";


const LoginForm = ({toggle, modal}) => {
   const emailRef = useRef();
   const passwordRef = useRef();

   const navigate = useNavigate();

   const currentUsers = useSelector(allUsers);
   const currentUser = useSelector(loggedInUser);
   const dispatch = useDispatch();

   const [errMessage, setErrMessage] = useState(null);

   async function handleLogin(e) {
      e.preventDefault();
      setErrMessage(null);
      const passwordEntered = passwordRef.current.value;
      const emailEntered = emailRef.current.value;

      const findUser = Object.values(currentUsers).find(val => ((val.email === emailEntered) && (val.password === passwordEntered)));

      if (findUser) {
         // dispatch(logUserIn({ ...findUser }));
         await dispatch(loginThunk({ ...findUser }));
      } else {
         console.log("There is No Such User:", findUser);
         setErrMessage(`Unable to find ${emailRef.current.value}!!!`)
      }
   }

   useEffect(() => {
      if (currentUser && currentUser._userID) {
         navigate(`/member/_userID/${currentUser._userID}/home`);
         if (modal) {
            toggle();
         }
      }
      return () => {
      };
   }, [currentUser._userID]);

   return (
      <Form className="loginForm" style={{
         border: "3.5px solid red",
         borderRadius: "15px",
      }} onSubmit={handleLogin}>
         {
            errMessage && <Alert color='danger'><h5>{errMessage}</h5></Alert>
         }
         <FormGroup>
            <Label htmlFor='email'>EMAIL</Label>
            <Input type='email' htmlFor='email' defaultValue="IFF-User1@gmail.com" style={{border: "3px solid black"}} innerRef={emailRef} required />
         </FormGroup>
         <FormGroup>
            <Label htmlFor='password'>PASSWORD</Label>
            <Input type='password' htmlFor='password' defaultValue="IFF-User1" style={{border: "3px solid black"}} innerRef={passwordRef} required />
         </FormGroup>
         <div className="d-grid gap-2">
            <button className="btn btn-danger" type="submit">LOGIN!!!</button>
         </div>
      </Form>
   )
}

export default memo(LoginForm);